import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Anchor = styled.span`
  display: inline;
  cursor: pointer;
  color: inherit;

  &,
  &:hover,
  &:focus,
  &:visited,
  &:active {
    text-decoration: none;
    color: inherit;
  }

  &::before,
  &:hover::before {
    display: none;
    content: none;
    width: 0;
  }
`;

export const NameLink = styled(Link)`
  color: inherit;

  &,
  &:hover,
  &:focus,
  &:visited,
  &:active {
    text-decoration: none;
    color: inherit;
  }

  &::before,
  &:hover::before {
    display: none;
    content: none;
    width: 0;
  }
`;

export const UsernameLink = styled(Link)`
  color: inherit;

  &,
  &:hover,
  &:focus,
  &:visited,
  &:active {
    text-decoration: none;
    color: inherit;
  }

  &::before,
  &:hover::before {
    display: none;
    content: none;
    width: 0;
  }
`;

export const TooltipStyles = styled.span`
  display: inline;

  .user-hover-tooltip {
    background-color: var(--bg) !important;
    color: var(--text) !important;
    border: 1px solid var(--bg-3) !important;
    box-shadow: var(--box-shadow) !important;
    border-radius: var(--border-radius) !important;
    opacity: 1 !important;
    padding: 6px 6px !important;
    font-weight: var(--wa-font-weight-normal) !important;
    z-index: 9999 !important;
  }

  .user-hover-tooltip .react-tooltip-arrow {
    border-bottom: 1px solid var(--bg-3) !important;
    border-right: 1px solid var(--bg-3) !important;
    background-color: var(--bg) !important;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 180px;
  max-width: 320px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: var(--xs-padding-horizontal);
  min-width: 0;
`;

export const HeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
`;

export const Name = styled.span`
  display: block;
  font-weight: 600;
  color: var(--text);
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Username = styled.span`
  display: block;
  font-size: var(--xs-font-size);
  color: var(--text);
  opacity: 0.75;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Separator = styled.hr`
  border: none;
  border-top: 1px solid var(--bg-3);
  margin: 0;
`;

export const SectionTitle = styled.h5`
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text);
  opacity: 0.6;
  margin: 0;
`;

export const StatusLine = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

export const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4em;
  font-size: var(--sm-font-size);
  min-width: 0;
  line-height: 1.4;
  color: ${({ $muted }) => ($muted ? 'var(--text-muted, var(--text))' : 'inherit')};
  opacity: ${({ $muted }) => ($muted ? 0.75 : 1)};
`;

export const ContactIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1em;
  font-size: 0.7rem;
  color: var(--text);
  opacity: 0.6;
`;

export const ContactValue = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`;

export const PrimaryBadge = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  font-size: 0.55rem;
  color: var(--orange, var(--wa-color-yellow));
`;

export const ShowMoreButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-top: 2px;
  font-size: var(--xs-font-size);
  color: var(--text);
  opacity: 0.6;
  cursor: pointer;
  text-align: left;
  line-height: 1.4;

  &:hover {
    color: var(--link);
    opacity: 1;
    text-decoration: underline;
  }
`;

export const RolesWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;
